"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rootPageSagas = void 0;
var WindowSaga_1 = require("@/pages/common/sagas/WindowSaga");
var RootLayoutSaga_1 = require("@/pages/common/sagas/RootLayoutSaga");
var BigpopupSaga_1 = require("@/pages/common/sagas/BigpopupSaga");
var QueueSaga_1 = require("@/pages/common/sagas/QueueSaga");
var GlobalSaga_1 = require("@/pages/common/sagas/GlobalSaga");
var PopupSaga_1 = require("@/pages/common/sagas/PopupSaga");
var ShareSagas_1 = require("@/pages/common/sagas/ShareSagas");
var ServerSideAnalyticSaga_1 = require("@/pages/common/sagas/ServerSideAnalyticSaga");
exports.rootPageSagas = {
    windowSagas: WindowSaga_1.windowSagas,
    rootLayoutSagas: RootLayoutSaga_1.rootLayoutSagas,
    bigpopupSagas: BigpopupSaga_1.bigpopupSagas,
    queueSagas: QueueSaga_1.queueSagas,
    globalSagas: GlobalSaga_1.globalSagas,
    popupSagas: PopupSaga_1.popupSagas,
    shareSagas: ShareSagas_1.shareSagas,
    serverSideAnalyticSagas: ServerSideAnalyticSaga_1.serverSideAnalyticSagas,
};
